export const settlementClassificationKeys = {
    all: ['settlementClassification'] as const,
    categories: (centerId: string) => [...settlementClassificationKeys.all, 'categories', centerId] as const,
    bulkJobs: (centerId: string, templateId: string) =>
        [...settlementClassificationKeys.all, 'bulkJobs', centerId, templateId] as const,
};
